import { useEffect } from 'react';

const SHOP_HERO_IMAGE = '/shop-hero.jpg';

const CALENDLY_URL = 'https://calendly.com/mandieozee/15min';

export default function ShopHeroSection() {
  useEffect(() => {
    document.title = 'Shop | The H.O.M.E Collection | MANDIE OZEE.';
  }, []);

  return (
    <section className="relative bg-[#1A1A1A] min-h-[70vh] md:min-h-[85vh] flex items-center overflow-hidden">
      {/* Background image with dark overlay */}
      <div className="absolute inset-0">
          <img
          src={SHOP_HERO_IMAGE}
          alt="The H.O.M.E Collection, Journal and Card Deck"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60 z-[1]" />
      </div>

      <div className="relative z-[2] w-full px-4 md:px-8 lg:px-12 py-24 md:py-32">
        <div className="max-w-3xl">
          {/* Eyebrow */}
          <p className="text-[#E8C86A] text-sm md:text-base font-body tracking-[0.25em] uppercase mb-6">
            A complete healing companion · Physical set
          </p>

          {/* Headline */}
          <h1 className="font-heading text-xl md:text-3xl lg:text-5xl text-white leading-tight mb-6 drop-shadow-lg">
            you don't need another self-help book.
            <br />
            you need somewhere to finally tell the truth.
            <br />
            and something to guide you every single day.
          </h1>

          {/* CTA Button */}
          <a
            href={CALENDLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center px-8 py-4 bg-[#D4006A] text-white text-sm font-body font-medium rounded-full hover:bg-[#B3005A] transition-colors duration-300 mb-4 w-full sm:w-auto"
          >
            Get The Collection
          </a>

          {/* Small text */}
          <p className="text-[#AAAAAA] text-xs font-body">
            Physical printed set · Journal + Card Deck · Shipped together
          </p>
        </div>
      </div>
    </section>
  );
}